import React, { useState } from 'react'
import { useLocation, useHistory } from 'react-router-dom'
import { isMobile } from 'react-device-detect'
import Loader from '../../Loader/Loader'
import { usePromiseTracker } from 'react-promise-tracker'

import {
  ScreenContainer,
  MainHeader,
  MainContentContainer,
  MainSubHeader,
  VerticalDivider,
  MealIngredientName,
  MealIngredientKcalValue,
  MealIngredientWeightValue,
  MealIngredientRow,
  MealsMainHeader,
  BigHeader,
  DietStandardRow,
  TextBold,
  DietStandardButton,
  TrashButton,
} from '../Shared/SharedStyledComponents'
import { TopColorBar } from '../../SelectSubscriptionPlanScreen/SelectSubscriptionPlanScreen.jsx'
import BackButton from '../../shared/BackButton'
import NavigationBar from '../../shared/NavigationBar/NavigationBarContainer'
import DemoModeAnnouncement from '../../DemoModeAnnouncement/DemoModeAnnouncement.jsx'

interface FilterMealsScreenProps {
  filterMealType: any
  filterKcal: any
  renderFilteredItems: any
  chosenMealTypeFilters: any
  chosenKcalFilters: any
  checkIfFilterIsChecked: any
  clearFilters: any
  diet: any
  isDemoAccount: boolean
}

const FilterMealsScreen: React.FC<FilterMealsScreenProps> = ({
  filterMealType,
  filterKcal,
  renderFilteredItems,
  chosenMealTypeFilters,
  chosenKcalFilters,
  checkIfFilterIsChecked,
  clearFilters,
  diet,
  isDemoAccount,
}) => {
  const location = useLocation()
  const history = useHistory()
  const { promiseInProgress } = usePromiseTracker()
  // const dietType = location.state.dietType

  const mealTypeFilters = [
    { text: 'ŚNIADANIA', value: 'Śniadanie', id: 0 },
    { text: 'II ŚNIADANIA', value: 'II śniadanie', id: 1 },
    { text: 'OBIADY', value: 'Obiad', id: 2 },
    { text: 'KOALCJE', value: 'Kolacja', id: 3 },
    { text: 'PRZEKĄSKA', value: 'Przekąska', id: 4 },
  ]
  const weightFilters = [
    { text: '50 - 200 kcal', valMin: 50, valMax: 199, id: 0 },
    { text: '200 - 300 kcal', valMin: 200, valMax: 299, id: 1 },
    { text: '300 - 400 kcal', valMin: 300, valMax: 399, id: 2 },
    { text: '400 - 500 kcal', valMin: 400, valMax: 499, id: 3 },
    { text: 'powyżej 500 kcal', valMin: 500, valMax: 100000000, id: 4 },
  ]

  // const useFilters = () => {
  //   history.go({
  //     path: '/',
  //   })
  // }

  return (
    <ScreenContainer>
      <TopColorBar relative>
        <BackButton
          place={'Szczegóły posiłku'}
          specialLocation={'/dieta'}
          alternativeColor={false}
          isActive={true}
        />
      </TopColorBar>
      <NavigationBar isPlayerView={false} />
      <MainHeader>Diety</MainHeader>
      <MainSubHeader>{diet && diet.diet_name}</MainSubHeader>
      <MealsMainHeader margin="30px 0 0 0 ">filtruj posiłki</MealsMainHeader>
      <TrashButton onClick={clearFilters} />

      <DietStandardRow
        width={'100%'}
        justify={isMobile ? 'start' : 'center'}
        margin="20px auto 0 auto"
        marginTop="40px"
      >
        <TextBold
          fSize="21"
          width="100%"
          textAlign={isMobile ? 'left' : 'center'}
        >
          Rodzaj posiłku
        </TextBold>
      </DietStandardRow>
      <DietStandardRow
        width={isMobile ? 'unset' : '100%'}
        justify={isMobile ? 'start' : 'center'}
        margin={isMobile ? '20px' : '20px auto 0 auto'}
        marginTop="40px"
      >
        {mealTypeFilters.map((button) => (
          <DietStandardButton
            color="white"
            backgroundColor={'#eccfff'}
            width={isMobile ? 'unset' : '10vw'}
            margin={isMobile ? ' 5px' : '0 15px'}
            fontSize={16}
            onClick={() => filterMealType(button)}
            className={`${
              checkIfFilterIsChecked('mealType', button) && 'checked'
            }`}
          >
            {button.text}
          </DietStandardButton>
        ))}
      </DietStandardRow>

      <DietStandardRow
        width={isMobile ? '100%' : '70%'}
        justify={isMobile ? 'start' : 'center'}
        margin="20px auto 0 auto"
        marginTop="60px"
      >
        <TextBold fSize="21">Wartość energetyczna</TextBold>
      </DietStandardRow>
      <DietStandardRow
        width={isMobile ? '100%' : '70%'}
        justify={isMobile ? 'start' : 'center'}
        margin={isMobile ? '20px' : '20px auto 0 auto'}
        marginTop="40px"
      >
        {weightFilters.map((button) => (
          <DietStandardButton
            color="white"
            backgroundColor={'#eccfff'}
            width={isMobile ? 'unset' : '10vw'}
            margin={isMobile ? ' 5px' : '0 15px'}
            fontSize={16}
            onClick={() => filterKcal(button)}
            className={`${checkIfFilterIsChecked('kcal', button) && 'checked'}`}
          >
            {button.text}
          </DietStandardButton>
        ))}
      </DietStandardRow>
      <DietStandardRow
        width={isMobile ? '100%' : '70%'}
        justify={isMobile ? 'start' : 'center'}
        margin="20px auto 0 auto"
        marginTop={isMobile ? '5px ' : '60px'}
      >
        <DietStandardButton
          backgroundColor="#fe0d9f"
          color="white"
          width={isMobile ? 'unset' : '10vw'}
          margin={isMobile ? '0 auto 100px auto ' : '0 15px'}
          fSize={21}
          onClick={renderFilteredItems}
        >
          Filtruj
        </DietStandardButton>
      </DietStandardRow>
      {isDemoAccount && <DemoModeAnnouncement />}
      {promiseInProgress && <Loader />}
    </ScreenContainer>
  )
}

export default FilterMealsScreen
